<template>
    <div>
        <b-table id="fulfillment-results" ref="fulfillmentResults" striped hover borderless
                 show-empty
                 selectable
                 :tbody-tr-class="$parent.rowClass"
                 head-variant="dark"
                 primary-key="id"
                 :busy="$parent.isBusy"
                 :fields="$parent.fields"
                 :items="$parent.getItems()"
                 :per-page="$parent.perPage"
                 :current-page="$parent.currentPage"
                 :sort-by.sync="$parent.sortBy"
                 :sort-desc.sync="$parent.sortDesc"
                 @row-selected="onRowSelected"
                 :filter="$parent.filter"
                 no-provider-paging
                 no-provider-sorting
                 no-provider-filtering>
            <template v-slot:head(selected)="row">
                <b-button size="sm" variant="outline-light" :pressed.sync="$parent.allSelected">
                    <i class="fa-regular fa-check fa-fw"></i>
                </b-button>
            </template>
            <template v-slot:cell(order.id)="data">
                <b-button variant="link" class="my-0 py-0" :to="'/kit/view/'+ data.item.order.id">{{
                        data.item.order.id
                    }}
                </b-button>
                <p class="text-muted font-sm" style="height: 0;">Lead: {{ data.item.id }}</p>
            </template>
            <template v-slot:cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                    <i class="fa-regular fa-check-square fa-fw"></i>
                </template>
                <template v-else>
                    <i class="fa-regular fa-square fa-fw"></i>
                </template>
            </template>
            <template v-slot:cell(name)="data">
                {{ data.item.customer.first_name }} {{ data.item.customer.last_name }}
            </template>
            <template v-slot:cell(requested_at)="data">
                {{ data.item.requested_at | datetime }}
            </template>
            <template v-slot:cell(status)="data">
                <span v-if="data.item.status === 'downloading'"><i class="fa-duotone fa-cloud-download-alt fa-fw"></i><i
                    class="fa-duotone fa-spinner fa-spin fa-fw"></i></span>
                <span v-else-if="data.item.status === 'downloaded'"><i
                    class="fa-duotone fa-cloud-download-alt fa-fw"></i><i
                    class="fa-duotone fa-file-check fa-fw text-success"></i></span>
                <span v-else-if="data.item.status === 'printing'"><i class="fa-duotone fa-print fa-fw"></i><i
                    class="fa-duotone fa-spinner fa-spin fa-fw"></i></span>
                <span v-else-if="data.item.status === 'printed'"><i class="fa-duotone fa-print fa-fw"></i><i
                    class="fa-regular fa-check fa-fw"></i></span>
                <span v-else>{{ data.item.status | titleCase }}</span>
            </template>
            <template v-slot:table-busy>
                <LoadingSpinner :busy="$parent.isBusy"/>
            </template>
        </b-table>

        <b-pagination
            v-model="$parent.currentPage"
            :total-rows="$parent.totalRows"
            :per-page="$parent.perPage"
            aria-controls="fulfillment-results"
            align="center"
            size="sm"
        ></b-pagination>
    </div>
</template>

<script>
import Lead from '@/models/Lead';
import LoadingSpinner from '../../components/LoadingSpinner';
import moment from 'moment';

export default {
    name: 'fulfillment-printed',
    components: {
        LoadingSpinner,
    },
    data() {
        return {
        };
    },
    computed: {

    },
    created() {
        this.refreshData();
    },
    methods: {
        fetchData(page = 1) {
            let vm = this.$parent;

            let promise = new Promise((resolve) => {
                let response = Lead
                    .include(['customer', 'order.brand', 'order', 'customer.orders'])
                    .where('status', 'printed')
                    .where('printed_date', moment().format('YYYY-MM-DD'))
                    .orderBy((vm.sortDesc ? '-' : '') + vm.sortBy)
                    .page(page)
                    .limit(vm.perPage)
                    .get();

                resolve(response);
            });

            return promise.then(response => {
                let items = response.data;

                // load additional paginated items
                if (response.next_page_url !== null) {
                    return this.fetchData(++page).then((nItems) => {
                        return items.concat(nItems);
                    });
                }

                return items;
            });
        },
        refreshData() {
            let vm = this.$parent;

            vm.isBusy = true;

            this.$emit('refresh');

            this.fetchData().then((items) => {
                vm.items = items;
                vm.totalRows = items.length;
                vm.isBusy = false;
            });
        },
        onRowSelected(items) {
            this.$parent.selected = items;
            if (items.length === 0) {
                this.$parent.allSelected = false;
            }
        },
        selectAllRows() {
            this.$refs.fulfillmentResults.selectAllRows();
        },
        clearSelected() {
            this.$refs.fulfillmentResults.clearSelected();
        },
    },
    watch: {

    }
};
</script>

<style scoped>

</style>
